import { Avatar, useTheme } from 'react-native-paper';
import { PaymentMethods } from 'ui';

import { Substatus, Status, PaymentMethod } from '../types';

type Props = {
  substatus: Substatus<Status>;
  paymentMethod: PaymentMethod;
};

export function SubstatusIcon({ substatus, paymentMethod }: Props) {
  const { colors } = useTheme();

  const warn = colors.tertiaryContainer;
  const act = colors.errorContainer;
  const ok = colors.surfaceVariant;

  const textColor = colors.onPrimaryContainer;

  function getIconProps() {
    switch (substatus) {
      // success

      case 'delivered':
        return { icon: 'check-circle-outline', backgroundColor: ok };

      // warnings

      case 'order_placed':
      case 'pending_consumer_validation':
        return { icon: 'clock-outline', backgroundColor: warn };

      case 'merchant_preparing_order':
        return { icon: 'package-variant', backgroundColor: warn };

      case 'package_accepted':
      case 'information_received':
      case 'ready_for_pickup':
      case 'pickup_failed_attempt':
      case 'out_for_delivery':
      case 'package_processing':
      case 'package_arrived':
      case 'package_departed':
        return { icon: 'truck-fast-outline', backgroundColor: warn };

      case 'required_consumer_validation':
      case 'retry_consumer_validation':
        return { icon: 'card-account-details-outline', backgroundColor: act };

      case 'delivery_attempted':
      case 'location_inaccessible':
      case 'address_issue':
        return { icon: 'alert-circle-outline', backgroundColor: act };

      case 'package_undeliverable':
      case 'rejected_consumer_validation':
      case 'definitive_pickup_failed_attempt':
      case 'return_to_sender':
        return { icon: 'close-circle-outline', backgroundColor: act };

      case 'manual_payment_pending': {
        switch (paymentMethod) {
          case 'yappy':
            return {
              icon: () => <PaymentMethods.Yappy color={textColor} />,
              backgroundColor: act,
            };
          case 'sinpe_movil':
            return {
              icon: () => <PaymentMethods.SinpeMovil color={textColor} />,
              backgroundColor: act,
            };
          case 'ach':
          case 'sinpe':
            return { icon: 'bank', backgroundColor: act };
          case 'cash':
            return { icon: 'cash', backgroundColor: act };
          case 'card':
          default:
            // noop - unreachable (in theory)
            return { icon: 'credit-card-outline', backgroundColor: act };
        }
      }
      default:
        // noop - unreachable (in theory)
        return { icon: '', backgroundColor: '' };
    }
  }

  const { icon, backgroundColor } = getIconProps();

  return (
    <Avatar.Icon
      icon={icon}
      size={40}
      color={textColor}
      style={{ backgroundColor }}
    />
  );
}
